import React, {useEffect, useState} from 'react'
import Button from '@components/Button'
import Alert from '@components/UIKit/Alert'
import useSessionStorageState from '@hooks/useSessionStorageState'
import useURLState from '@hooks/useURLState'
import useUserId from '@hooks/useUserId'
import classnames from 'classnames'
import {useRouter} from 'next/router'
import {useTranslation} from 'next-i18next'

import UpdateBasicOptions from '../../Options/UpdateBasicOptions'

import Login from './TableOrders/Login'
import Item from './Item'
import Resume from './Resume'
import TableOrders from './TableOrders'
import useUserOrderGroup from './useUserOrderGroup'
import useWhatsAppCommerceNumber from './useWhatsAppCommerceNumber'

import styles from './styles.module.css'

export default function Content(props) {
  const {preferences, website, layout, refetch, setOpenResume, defaultScreen = 'resume'} = props
  const cart = preferences.cart
  const {storeId} = preferences
  const userId = useUserId()
  const [showCart, setShowCart] = useState(layout === 'v2' && !storeId ? false : true)
  const {t} = useTranslation()
  const i18nWebsite = 'website:order.cart'
  const i18nGeneric = 'generic:fields'
  const whatsappChatCommerceNumber = useWhatsAppCommerceNumber(website._id, preferences)
  const [showScreen, setShowScreen] = useState(defaultScreen)
  const [onTable] = useSessionStorageState('onTable')
  const router = useRouter()
  const userOrderGroup = useUserOrderGroup({website, storeId, preferences})
  const [showLogin, setShowLogin] = useSessionStorageState('onTable.showLogin', true)
  const [seeTableOrder] = useURLState('seeTableOrder')
  const isOpenQueryParam = seeTableOrder === 'true'

  useEffect(() => {
    if (isOpenQueryParam) setShowScreen('tableOrders')
  }, [isOpenQueryParam, seeTableOrder])

  async function checkPlease() {
    router.push('/checkout-on-table/checkout')
  }

  if (!cart) return null

  if (showLogin && onTable && !userId) {
    return <Login preferences={preferences} setShowLogin={setShowLogin} />
  }

  if (!showCart) {
    return (
      <div className={styles.optionsContent}>
        <UpdateBasicOptions preferences={preferences} />
        <div className={styles.buttonContinue}>
          <Button disabled={!storeId} onClick={() => setShowCart(true)} primary>
            {t(`${i18nGeneric}.continue`)}
          </Button>
        </div>
      </div>
    )
  }

  const closeTable =
    onTable && userOrderGroup ? (
      <div className={styles.buttonCloseTable}>
        <Button fullWidth onClick={checkPlease}>
          {t(`${i18nWebsite}.payAndCloseTable`)}
        </Button>
      </div>
    ) : null

  const tabs = onTable ? (
    <div className={styles.tabsButtons}>
      <div
        className={classnames(styles.option, showScreen === 'resume' ? styles.active : null)}
        onClick={() => setShowScreen('resume')}>
        {t(`${i18nWebsite}.currentOrder`)}
      </div>
      <div
        className={classnames(styles.option, showScreen === 'tableOrders' ? styles.active : null)}
        onClick={() => setShowScreen('tableOrders')}>
        {t(`${i18nWebsite}.totalAmount`)}
      </div>
    </div>
  ) : null

  if (showScreen === 'tableOrders') {
    if (!userOrderGroup)
      return (
        <>
          {tabs}
          <div>
            <Alert description={t(`${i18nWebsite}.noOrdersSentToKitchen`)} />
          </div>
        </>
      )

    return (
      <>
        {tabs}
        <TableOrders
          preferences={preferences}
          ordersGroupedByUser={userOrderGroup.ordersGroupedByUser}
          tableTotal={userOrderGroup.tableTotal}
          setOpenResume={setOpenResume}
        />
      </>
    )
  }

  if (cart.items.length === 0) {
    return (
      <>
        {tabs}
        <div className={styles.empty}>{t(`${i18nWebsite}.emptyCart`)}</div>
        {closeTable}
      </>
    )
  }

  if (showCart) {
    return (
      <div className={styles.container}>
        {tabs}
        <div className={styles.items}>
          {cart.items.map(item => (
            <Item
              key={item._id}
              item={item}
              preferences={preferences}
              readOnly={false}
              amountClassname={''}
            />
          ))}
        </div>
        {cart.items.length > 5 ? <div className={styles.shadow} /> : null}
        <Resume
          website={website}
          cart={cart}
          preferences={preferences}
          whatsappChatCommerceNumber={whatsappChatCommerceNumber}
          refetch={refetch}
        />
        {closeTable}
      </div>
    )
  }
}
